var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("AgGridVue", {
    staticClass: "ag-grid--custom ag-grid--insights ag-theme-balham-dark",
    attrs: {
      "grid-options": _vm.gridOptions,
      "column-defs": _vm.gridColDefs,
      "column-types": _vm.colTypes,
      "default-col-def": _vm.defaultColDef,
      "auto-group-column-def": _vm.autoGroupColumnDef,
      "row-buffer": _vm.rowBuffer,
      "row-model-type": _vm.rowModelType,
      "cache-block-size": _vm.cacheBlockSize,
      "max-blocks-in-cache": _vm.maxBlocksInCache,
      "row-height": 29.6,
      "row-group-panel-show": "never",
      "side-bar": _vm.sideBar,
      "animate-rows": false,
      debug: _vm.debug,
      "get-row-node-id": _vm.getRowNodeId,
      "group-include-footer": true,
      "group-include-total-footer": true,
      "group-remove-lowest-single-children": true,
      "group-default-expanded": -1,
      "suppress-agg-func-in-header": true,
      "suppress-column-state-events": false,
      "suppress-column-move-animation": true,
      "suppress-make-column-visible-after-un-group": true,
      "suppress-property-names-check": true,
      "pivot-mode": false,
      "row-class-rules": _vm.rowClassRules,
      "get-main-menu-items": _vm.getMainMenuItems,
      "group-header-height": 0,
      "framework-components": _vm.frameworkComponents,
      "loading-cell-renderer": _vm.loadingCellRenderer,
      "loading-cell-renderer-params": _vm.loadingCellRendererParams,
      "block-load-debounce-millis": 1000,
      "suppress-context-menu": true,
      icons: _vm.customIcons,
      "suppress-animation-frame": true,
      "tooltip-show-delay": 0
    },
    on: {
      "grid-ready": _vm.onGridReady,
      rowGroupOpened: _vm.onRowGroupOpened,
      filterChanged: _vm.onFilterChange,
      sortChanged: _vm.onSortChange,
      columnPivotModeChanged: _vm.onPivotModeChange,
      columnPivotChanged: _vm.onPivotChange,
      columnVisible: _vm.onColVisChange,
      columnMoved: _vm.onColumnMoved,
      columnPinned: _vm.onColPinChange,
      columnResized: _vm.onColResizeChange,
      columnValueChanged: _vm.onColumnValueChanged,
      cellClicked: e => _vm.$emit("cellClicked", e)
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }